import { getAuth, signOut } from "firebase/auth";
import app from './firebaseConfig';

const auth = getAuth(app);

export const authLogoutUser = () => {
  return signOut(auth);
}